import * as React from 'react';
import { metadataServiceInstance, zenDataServiceInstance } from '@/services';
import { SvgAnnotations } from '../svg-annotations';
import { IllustratorTextType } from "@/common/enums";

enum ETextAnchor {
    Left = "start",
    Middle = "middle",
    Right = "end",
}

SvgAnnotations.RegisterAnnotationCallback("TEXTDETAILS", ({ svgEditService, bbox, element, svgAnnotations, defs }) => {
    if (!element || element.tagName.toLowerCase() !== "text") {
        return;
    }

    const zoomLevel = svgEditService.canvas.getCurrentZoom();
    let textLimitWidth = Number.parseFloat(element.getAttribute("pe-textwidthlimit") ?? "0.0");
    let textLimitHeight = bbox.bottom - bbox.top;

    if(textLimitWidth <= 0 && zenDataServiceInstance.GetDesignerMode() === "artwork") {
        const textBoxMetadata = metadataServiceInstance.getMetadataForElement(element);
        if(textBoxMetadata.text_element_type !== IllustratorTextType.PointText) {
            if(textBoxMetadata?.element_positional_info) {
                textLimitWidth = textBoxMetadata.element_positional_info.width;
                textLimitHeight = textBoxMetadata.element_positional_info.height;
            } else {
                textLimitWidth = bbox.width;
            }
        }
    }
    const textAnchor = element.getAttribute("text-anchor");
    const textWidthLimitMode = element.getAttribute("pe-textwidthlimit-mode");
    const wrapLines = textWidthLimitMode === "wrap" ? parseInt(element.getAttribute("pe-maxlines") ?? "1") : 1;
    const lineHeight = parseFloat(element.getAttribute("pe-lineheight") ?? "1.2")

    if (textLimitWidth > 0) {
        let left = bbox.left;

        if (wrapLines > 1) {
            textLimitHeight += textLimitHeight * (wrapLines - 1) * lineHeight;
        }

        const textLimitWidthDisplay = textLimitWidth * zoomLevel;
        const textLimitHeightDisplay = textLimitHeight * zoomLevel;

        switch (textAnchor) {
            case ETextAnchor.Right:
                left = left - textLimitWidthDisplay + bbox.width;
                break;

            case ETextAnchor.Middle:
                left = left - textLimitWidthDisplay / 2.0 + bbox.width / 2.0;
                break;

            case ETextAnchor.Left:
            default:
                break;
        }


        svgAnnotations.push((
            <rect x={left} y={bbox.top} width={textLimitWidthDisplay} height={textLimitHeightDisplay} stroke="#FF2222" strokeWidth={3} fill="none" />
        ));
    }

    const marginBottom = parseFloat(element.getAttribute("pe-paragraphpadding-btm") ?? "0");
    if (marginBottom > 0) {
        const svgcontent = document.getElementById("svgcontent") as unknown as SVGSVGElement;
        const docX = svgcontent.x.baseVal.value - SvgAnnotations.OffsetX;
        const docY = svgcontent.y.baseVal.value - SvgAnnotations.OffsetY;

        const topEdge = (svgEditService.canvas.contentH - marginBottom) * zoomLevel;
        const rightEdge = svgEditService.canvas.contentW * zoomLevel;

        defs.push((
            <pattern key="compRep_hatchPatternDef" id="comp-repeat-docpad-hatch" width="10" height="10" patternUnits="userSpaceOnUse">
                <path stroke="rgba(255,0,0,0.4)" strokeLinecap="round" strokeWidth="1" d="M 5,5 L 10,10" />
                <path stroke="rgba(255,0,0,0.4)" strokeLinecap="round" strokeWidth="1" d="M 5,5 L 0,10" />
                <path stroke="rgba(255,0,0,0.4)" strokeLinecap="round" strokeWidth="1" d="M 5,5 L 10,0" />
                <path stroke="rgba(255,0,0,0.4)" strokeLinecap="round" strokeWidth="1" d="M 5,5 L 0,0" />
            </pattern>
        ));

        svgAnnotations.push((
            <rect key="compRep_paddingBottomDangerFill" x={docX} y={docY + topEdge} width={rightEdge} height={marginBottom * zoomLevel} fill="url(#comp-repeat-docpad-hatch)" pointerEvents="none" />
        ));
        svgAnnotations.push((
            <line key="compRep_paddingBottomDangerStroke" x1={docX} y1={docY + topEdge} x2={docX + rightEdge} y2={docY + topEdge} stroke="rgba(255,0,0,0.7)" strokeWidth={2} pointerEvents="none" />
        ));
    }
});
